import { Route } from 'types/route.type';
import EditManualFeed from './components/edit-manual-feed';
import ListManualFeeds from './list-manual-feeds';

export const routes: Route[] = [
  {
    path: '/feed-management/manual-feeds',
    component: ListManualFeeds,
    id: 'feedManagement.navigation.listManualFeeds',
  },
  {
    path: '/feed-management/manual-feeds/:id',
    component: EditManualFeed,
  },
];
